import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M21 12a9 9 0 1 0 -9 9","key":"svg-0"}],["path",{"d":"M12 7v5l1 1","key":"svg-1"}],["path",{"d":"M16 16h6v6h-6l0 -6","key":"svg-2"}]]

/**
 * IconClockStop
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY2xvY2stc3RvcCIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMjEgMTJhOSA5IDAgMSAwIC05IDkiIC8+CiAgPHBhdGggZD0iTTEyIDd2NWwxIDEiIC8+CiAgPHBhdGggZD0iTTE2IDE2aDZ2NmgtNmwwIC02IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/clock-stop
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconClockStop = createReactComponent('outline', 'clock-stop', 'ClockStop', __iconNode);

export default IconClockStop;